import { TenantConfig, TenantInstance, TenantId } from './types';
import { CLIENT_ENV } from '../constants/env';
import { gskConfig } from './gsk/config';
import { hexalConfig } from './hexal/config';
import { incyteConfig } from './incyte/config';
import { novartisConfig } from './novartis/config';
import { nvsConfig } from './nvs/config';
import { seqirusConfig } from './seqirus/config';

export const tenantConfigs: TenantConfig[] = [
  incyteConfig,
  hexalConfig,
  novartisConfig,
  nvsConfig,
  gskConfig,
  seqirusConfig,
];

export function getTenantConfigById(id: TenantId): TenantConfig {
  const tenant = tenantConfigs.find((item) => item.id === id);
  if (!tenant) {
    throw new Error(`[tenant]: Unknown tenant '${id}'`);
  }
  return tenant;
}

export function getTenantFromEnv(): TenantConfig {
  if (!CLIENT_ENV) {
    throw new Error('[tenant]: VITE_CLIENT is not set');
  }
  return getTenantConfigById(CLIENT_ENV as TenantId);
}

export function getInstanceFromUrl(): string | null {
  const pathParts = window.location.pathname.split('/');
  const instanceIndex = pathParts.indexOf('instance');
  return instanceIndex !== -1 ? pathParts[instanceIndex + 1] : null;
}

export function getCurrentInstance(): TenantInstance {
  const tenant = getTenantFromEnv();
  const instanceFromUrl = getInstanceFromUrl();
  if (instanceFromUrl) {
    const match = tenant.instances.find((item) => item.id === instanceFromUrl);
    if (match) return match;
    throw new Error('[tenant]: Instance not found');
  }
  const defaultInstance = tenant.instances.find((item) => item.isDefault);
  if (!defaultInstance) {
    throw new Error('[tenant]: Default instance not found');
  }
  return defaultInstance;
}

export const CURRENT_TENANT = getTenantFromEnv();
export const CURRENT_INSTANCE = getCurrentInstance();
